import { render, staticRenderFns } from "./gateway-info.vue?vue&type=template&id=f68fe60a"
import script from "./gateway-info.vue?vue&type=script&lang=js"
export * from "./gateway-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports